import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_equal",
  "use": "icon-icon_equal-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-icon_equal\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h8v8H0z\" /><rect fill=\"#9B9CA3\" x=\"1.703\" y=\"4.018\" width=\"4.6\" height=\"1\" rx=\".5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol